export default function getConditionalStyle(
  {
    inputContainer,
    input,
    iconContainer,
    iconColor,
    magazineContainer,
    clearSelection,
    noMatchMessage
  },
  { disabled, hasError, isRtl, inputIsFocused, showPlaceholder }
) {
  return {
    inputContainer: {
      ...inputContainer.base,
      ...(isRtl ? inputContainer.rtl : {}),
      ...(hasError ? inputContainer.hasError : {}),
      ...(disabled ? inputContainer.disabled : {}),
      ...(inputIsFocused
        ? (hasError && inputContainer.focus.hasError) ||
          inputContainer.focus.base
        : {})
    },
    input: {
      ...input.base,
      ...(isRtl ? input.rtl : {}),
      ...(showPlaceholder ? input.placeholder : {}),
      ...(disabled ? input.disabled : {})
    },
    iconContainer: {
      ...iconContainer.base,
      ...(isRtl ? iconContainer.rtl : {})
    },
    iconColor: {
      ...(disabled ? iconColor.disabled : iconColor.base)
    },
    magazineContainer: {
      ...magazineContainer.base
    },
    clearSelection: {
      ...clearSelection.base
    },
    noMatchMessage: {
      ...noMatchMessage.base
    }
  };
}
